import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
@Directive({
  selector: '[numberCustom]'
})
export class NumberCustomDirective {
  @Input() regex: RegExp;
  @Input() formControl: FormControl;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onKeyDown(event: InputEvent) {
    const current = (event.target as HTMLInputElement).value;
    if (current && !String(current).match(this.regex)) {
      const position = this.el.nativeElement.selectionStart;
      this.formControl.setValue(current.substring(0, (position - 1)) + current.substring(position));
    }
  }
}
